import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_ALL_OUTPUTS = registerQuery({
  fieldName: 'allOutputs',
  args: ['flowId', 'flowVersion'],
  fetcher({
    flowId
  }) {
    return http.get(`automationplatform/v1/output-fields/flow/${flowId}/allOutputs`);
  }
});